import AddExercise from './AddExercise';

export default AddExercise;
